import { render } from "./AccessViewModal.vue?vue&type=template&id=7b95cd5e&scoped=true"
import script from "./AccessViewModal.vue?vue&type=script&lang=js"
export * from "./AccessViewModal.vue?vue&type=script&lang=js"

import "./AccessViewModal.vue?vue&type=style&index=0&id=7b95cd5e&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b95cd5e"]])

export default __exports__